import React, { useMemo } from 'react';
import { Table } from '@weezevent/nacre';
import css from '../../../styles.module.css';
import TableError from './TableError';

function Row({ index, onPaste, onChange, attendee }) {
    const checkValid = useMemo(() => {
        return attendee.valid && attendee.email !== null && attendee.email !== undefined;
    }, [attendee]);

    return (
        <Table.Row name="attendees">
            <Table.Cell content={index + 1} />
            <Table.Cell
                content={<input name="lastname" onPaste={onPaste} data-id={index} value={attendee.lastname} onChange={e => onChange('lastname', e.target.value)} type="text" />}
            />
            <Table.Cell
                content={<input name="firstname" onPaste={onPaste} data-id={index} value={attendee.firstname} onChange={e => onChange('firstname', e.target.value)} type="text" />}
            />
            <Table.Cell
                content={
                    <input
                        name="quantity"
                        onPaste={onPaste}
                        data-id={index}
                        value={attendee.quantity}
                        max={50} // Max value to prevent sending too many orders with too many attendees to Pyvar
                        onChange={e => onChange('quantity', e.target.value)}
                        type="number"
                    />
                }
            />
            <Table.Cell
                content={
                    <div className={css['email-input']}>
                        <input
                            className={`${!attendee.valid ? css['valid'] : css['invalid']}`}
                            name="email"
                            onPaste={onPaste}
                            data-id={index}
                            value={attendee.email}
                            onChange={e => onChange('email', e.target.value)}
                            type="email"
                        />
                        {checkValid && <TableError />}
                    </div>
                }
            />
        </Table.Row>
    );
}

export default Row;
